export default __webpack_public_path__ + "static/2150-d4c87d9ab58d370e33092739c3fb3e9b.gif";